import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import betReducer from "./slices/betSlice";
import bonusReducer from "./slices/bonusSlice";
import casinoReducer from "./slices/casinoSlice";
import gameReducer from "./slices/gameSlice";
import ledgerReducer from "./slices/ledgerSlice";
import logoReducer from "./slices/logoSlice";
import matchesReducer from "./slices/matchesSlice";
import multiMarketReducer from "./slices/multiMarketSlice";
import newsReducer from "./slices/newsSlice";
import profileReducer from "./slices/profileSlice";
import sidebarReducer from "./slices/sidebarSlice";
import sportReducer from "./slices/sportSlice";
import sportEventReducer from "./slices/sportEventSlice";
import statementReducer from "./slices/statementSlice";
import walletReducer from "./slices/walletSlice";
import withdrawReducer from "./slices/withdrawSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    matches: matchesReducer,
    bet: betReducer,
    game: gameReducer,
    statement: statementReducer,
    ledger: ledgerReducer,
    news: newsReducer,
    multiMarket: multiMarketReducer,
    sport: sportReducer,
    sportEvent: sportEventReducer,
    sidebar: sidebarReducer,
    profile: profileReducer,
    withdraw: withdrawReducer,
    wallet: walletReducer,
    casino: casinoReducer,
    logo: logoReducer,
    bonus: bonusReducer,
  },
});

if (process.env.NODE_ENV === "development") {
  window.store = store;
}
